import { render, staticRenderFns } from "./moveGrv.vue?vue&type=template&id=121989d8"
import script from "./moveGrv.vue?vue&type=script&lang=js"
export * from "./moveGrv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports